import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Action {
  label: string;
  action: string;
  icon: string;
}

@Component({
  selector: 'record-list-item-actions',
  templateUrl: './record-list-item-actions.component.html',
  styleUrls: ['./record-list-item-actions.component.scss']
})
export class RecordListItemActionsComponent {

  @Input() actions: Action[];

  @Output() action: EventEmitter<any> = new EventEmitter();

  /**
   * Action event handler
   * @param action 
   */
  onAction(action: string): void {
    this.action.emit(action);
  }

}
